/**
 * used to request a drug search
 */
export class DrugSearchRequest {
    public WebRegionId!: number;
    public DrugName!: string;
}
